import React from "react";
import MarketingLayout from "./components/MarketingLayout.js";
import "./Roadmap.css";

export default function Roadmap() {
  return (
    <MarketingLayout>
      <div className="roadmap-page">
      <div className="roadmap-content">
        <h1>Product Roadmap</h1>
        <p className="roadmap-subtitle">
          Our product direction and feature lists from planning. We ship in phases and keep this updated.
        </p>

        <section className="roadmap-section">
          <h2><span className="roadmap-icon">📄</span> Standard business pages</h2>
          <p><strong>Ask:</strong> “Do you want standard business pages generated?”</p>
          <ul>
            <li>About Us</li>
            <li>Contact Us</li>
            <li>Privacy Policy</li>
            <li>Terms of Service</li>
            <li>Cookie Policy</li>
            <li>Refund Policy (only if payments enabled)</li>
          </ul>
        </section>

        <section className="roadmap-section">
          <h2><span className="roadmap-icon">✏️</span> Google Docs–style page editing</h2>
          <ul>
            <li><strong>Rich Text / Formatting</strong>: bold/italic, lists, headings, links, blockquotes, alignment/colors/highlights</li>
            <li><strong>Media Embeds</strong>: drag/drop images, videos, charts, GIFs; AI placement/captions</li>
            <li><strong>Versioning & Branching</strong>: compare, rollback, experiment safely</li>
            <li><strong>AI Assistance</strong>: rewrite/formal/shorten/mobile; inline suggestions</li>
            <li><strong>Drag-and-drop page/section reordering</strong></li>
            <li><strong>Collaboration (later)</strong>: cursors, comments, approvals</li>
            <li><strong>Validation & guidance</strong>: SEO, completeness, accessibility</li>
          </ul>
        </section>

        <section className="roadmap-section">
          <h2><span className="roadmap-icon">🔮</span> Future / visionary</h2>
          <ol>
            <li>Autonomous Creative Agents</li>
            <li>Predictive Multi-Project Planning</li>
            <li>Generative Mixed Reality (AR/VR/3D)</li>
            <li>Self-Updating AI Content</li>
            <li>Hyper-Personalization for Audiences</li>
            <li>AI Governance & Ethical Compliance</li>
            <li>Full-Spectrum Business Automation</li>
            <li>Creative Marketplace & Network AI</li>
            <li>Emotion & Engagement AI</li>
            <li>Global Problem Solving</li>
          </ol>
        </section>

        <p className="roadmap-canonical">
          Canonical version: <code>docs/ZOLAID_VISION.md</code>
        </p>
      </div>
      </div>
    </MarketingLayout>
  );
}
